export default "__VITE_ASSET__Bj_lcJa7__"